import { Cancel, ErrorOutlined, InfoOutlined } from "@mui/icons-material";
import { Button, CircularProgress, Paper, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import { Colors } from "../../config/Constants";

/**
 * Component to show loading on different tabs 
 * @param params 
 * @returns 
 */
export function DashboardLoader(params: {
  loading?: boolean;
  error?: boolean;
  message?: string;
  styles: {
    containerSx?: SxProps<Theme>,
    iconSx?: SxProps<Theme>,
    elevation?: number
  },
  customIcon?: ReactNode,
  resetError?: () => any
  resetErrorText?: string
  resetErrorIcon?: ReactNode
  resetErrorIconPrefix?: boolean
}) {

  // Generate icon
  let icon;
  const iconStyle = { ...(params.error && { color: Colors.failureRed }) };
  if (params.error)
    icon = <ErrorOutlined className="icon" style={iconStyle} />;
  else if (params.loading)
    icon = <CircularProgress className="icon" style={iconStyle} />;
  else
    icon = params.customIcon ? params.customIcon : <InfoOutlined className="icon" style={iconStyle} />;

  // Generate text
  let text;
  if (!params.message)
    text = '';
  else if (params.error)
    text = params.message;
  else if (params.loading)
    text = params.message;
  else
    text = params.message;

  // Generate button if required
  let button: ReactNode = '';
  if (params.resetError) {
    button = (
      <div style={{ display: 'block', textAlign: 'center' }}>
        <Button
          color='inherit'
          onClick={() => params.resetError && params.resetError()}
          className='gbk-icon-span'
        >
          {params.resetErrorIconPrefix ? params.resetErrorIcon || <Cancel /> : undefined}
          &nbsp; {params.resetErrorText || 'DISMISS'} &nbsp;
          {!params.resetErrorIconPrefix ? params.resetErrorIcon || <Cancel /> : undefined}
        </Button>
      </div>
    )
  }

  return (
    <Paper elevation={params.styles.elevation || 1} className="dashboard-loader" sx={params.styles.containerSx || {}}>
      {icon}
      <span className={`text ${params.error ? 'error-text' : ''}`}>
        {text}
      </span>
      <br />
      <br />
      {button}
    </Paper>
  );
}